import * as React from 'react';

import { WhatsAroundTransportation } from 'models';

import { WhatsAroundListItem } from './list-item';

interface NearbyTransportationProps {
  nearbyTransportationList: WhatsAroundTransportation[];
}

export const NearbyTransportation: React.FunctionComponent<NearbyTransportationProps> = ({ nearbyTransportationList }) => {
  const transportationListItems = nearbyTransportationList.map((transportation, index) => {
    if (!transportation) {
      return null;
    }
    const { category, content } = transportation;
    if (!(category && content)) {
      return null;
    }
    const liKeyBase = `location-${index}`;

    return (
      <WhatsAroundListItem
        category={category}
        iconId={`transportation__list-icon-${index}`}
        id={liKeyBase}
        liClassName="transportation__list-item"
        liContent={content}
        key={liKeyBase}
        displayIcons={true}
      />
    );
  });

  return (
    <ul className="uitk-type-list-300 transportation__list icon-s" data-stid="whats-around-transportation">
      {transportationListItems}
    </ul>
  );
};
